export default __webpack_public_path__ + "static/media/ntorq-125-race-moto.4f9c8a70.png";